/**
 * Formats text by removing underscores and converting to proper case
 * @param text - The text to format (e.g., "REGISTERED_COMPLAINT")
 * @returns Formatted text (e.g., "Registered Complaint")
 */
export const formatText = (text: string): string => {
  if (!text) return "";
  
  return text
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
